import React from "react";
import TopBanner from "../components/banner/topBanner";
import { Banners } from "../components/data";
import WebBlock from "../components/blocks/webBlock";


export default function Web() {
    return(
        <div className="Web">
            <TopBanner title={Banners[1].title}/>
            <WebBlock />
        </div>
    )
}